module.exports = __webpack_public_path__ + "static/media/snack-picto.c6aac26b.svg";